import { useEffect, useState } from 'react'

// TeamPanel marks its root with this attribute.
const PANEL_SELECTOR = '[data-team-panel]'

const inPanel = (target: EventTarget | null) =>
  target instanceof Element && target.closest(PANEL_SELECTOR) !== null

// True while the user works in the chat panel; a click or focus anywhere else in the page ends it.
export const useChatFocused = (): boolean => {
  const [focused, setFocused] = useState(() => inPanel(document.activeElement))

  useEffect(() => {
    const onEnter = (e: Event) => setFocused(inPanel(e.target))
    document.addEventListener('focusin', onEnter, true)
    document.addEventListener('pointerdown', onEnter, true)
    return () => {
      document.removeEventListener('focusin', onEnter, true)
      document.removeEventListener('pointerdown', onEnter, true)
    }
  }, [])

  return focused
}
